import { GET_DATA_MENU_ALL_SUCCEEDED, REQUERT_MENU_ALL_FAILED } from "../actions/actionTypes";


const menuReducer = (DataMenu = [], actions) =>{
    switch (actions.type) {
        case GET_DATA_MENU_ALL_SUCCEEDED:
            if(Object.keys(actions.DataMenu).length > 0)
            {
                return {...DataMenu,DataMenu: actions.DataMenu};
            }
            else
            {
                return {...DataMenu,DataMenu: []};
            }
        case REQUERT_MENU_ALL_FAILED:
            return {...DataMenu,DataMenu: []}
        default:
            return DataMenu;
    }
}

export default menuReducer;